import { IconButton } from '@vapor/material'
import { useSnackbar } from 'notistack'
import { useCallback } from 'react'
import CloseIcon from '@mui/icons-material/Close'

const useInfoSnackBar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const showInfoSnackBar = useCallback(
    (message: string) => {
      return enqueueSnackbar(message, {
        variant: 'info',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        action: (key) => {
          return (
            <IconButton
              aria-label="close"
              color="inherit"
              sx={{ p: 0.5 }}
              onClick={() => {
                closeSnackbar(key)
              }}
            >
              <CloseIcon />
            </IconButton>
          )
        },
      })
    },
    [enqueueSnackbar, closeSnackbar],
  )

  return showInfoSnackBar
}

export default useInfoSnackBar
